'use client';

import { motion, useScroll, useTransform } from 'framer-motion';
import { memo } from 'react';

export const BackGroundSvg = memo(() => {
  const { scrollY } = useScroll();

  // 스크롤 값을 600으로 제한하여 그 이후에는 업데이트하지 않음
  const y1 = useTransform(scrollY, [0, 500], [0, 150], { clamp: true });
  const y2 = useTransform(scrollY, [0, 500], [0, 100], { clamp: true });
  const y3 = useTransform(scrollY, [0, 500], [0, 75], { clamp: true });
  const y4 = useTransform(scrollY, [0, 500], [0, 125], { clamp: true });
  const y5 = useTransform(scrollY, [0, 500], [0, 175], { clamp: true });

  const opacity = useTransform(scrollY, [0, 300, 600], [1, 0.9, 0.7], {
    clamp: true,
  });
  const scale = useTransform(scrollY, [0, 500], [1, 1.05], { clamp: true });

  const springTransition = {
    type: 'spring',
    stiffness: 100,
    damping: 25,
    mass: 0.8,
    delay: 4,
  };

  const smoothTransition = {
    duration: 0.8,
    delay: 4,
    ease: [0.25, 0.1, 0.25, 1],
  };

  return (
    <>
      <motion.path
        d="M200.194 391.694L210.242 325.893L256.178 382.312L379 359.835V36L272.847 80.6891L273.9 203.292L225.534 100.418L146.565 133.427L133.1 224.699L100.652 152.593L4 192.996L102.907 408L200.194 391.694Z"
        fill="url(#blueGradient)"
        initial={{ opacity: 0.6, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ ...smoothTransition, delay: 0 }}
        style={{
          y: y1,
          opacity,
        }}
      />

      <motion.path
        d="M379 513.092V371L105 418.236L133.002 517L379 513.092Z"
        fill="url(#redGradient1)"
        initial={{ opacity: 0.6, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ ...springTransition, delay: 0.1 }}
        style={{
          y: y2,
          scale,
        }}
      />

      <motion.path
        d="M-5 439.329L-3.22648 442L93 410.902L-5 198V439.329Z"
        fill="url(#redGradient2)"
        initial={{ opacity: 0.6, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ ...smoothTransition, delay: 0.15 }}
        style={{
          y: y3,
          opacity,
        }}
      />

      <motion.path
        d="M16.9123 491.028C24.4543 517.29 52.0908 532.58 78.6695 525.102C105.199 517.638 120.627 490.229 113.088 463.967C105.546 437.705 77.8596 422.429 51.3305 429.893C24.8014 437.359 9.37275 464.766 16.9123 491.031"
        fill="url(#blueGradient2)"
        initial={{ opacity: 0.5, scale: 0.9 }}
        animate={{
          opacity: 1,
          scale: 1,
          y: [0, -12, 0],
        }}
        transition={{
          opacity: { ...smoothTransition, delay: 0.2 },
          scale: { ...springTransition, delay: 0.2 },
          y: {
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 0.8,
          },
        }}
        style={{
          y: y4,
        }}
      />

      <motion.path
        d="M-149.364 945.64L19.1672 1058.94L198.748 720.829L57.5282 672.779L-149.364 945.64Z"
        fill="url(#redGradient3)"
        initial={{ opacity: 0.5, scale: 0.98 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ ...smoothTransition, delay: 0.25 }}
        style={{
          y: y5,
          opacity,
        }}
      />

      <defs>
        <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#1C9CFF" stopOpacity="1" />
          <stop offset="100%" stopColor="#0D7FE8" stopOpacity="0.9" />
        </linearGradient>

        <linearGradient id="blueGradient2" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#1C9CFF" stopOpacity="1" />
          <stop offset="50%" stopColor="#2BA7FF" stopOpacity="0.95" />
          <stop offset="100%" stopColor="#0D7FE8" stopOpacity="0.85" />
        </linearGradient>

        <linearGradient id="redGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF5C36" stopOpacity="1" />
          <stop offset="100%" stopColor="#FF4520" stopOpacity="0.9" />
        </linearGradient>

        <linearGradient id="redGradient2" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF5C36" stopOpacity="0.95" />
          <stop offset="100%" stopColor="#FF6B48" stopOpacity="0.85" />
        </linearGradient>

        <linearGradient id="redGradient3" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF5C36" stopOpacity="0.9" />
          <stop offset="50%" stopColor="#FF4520" stopOpacity="0.85" />
          <stop offset="100%" stopColor="#E63E1C" stopOpacity="0.8" />
        </linearGradient>
      </defs>
    </>
  );
});

BackGroundSvg.displayName = 'BackGroundSvg';
